import React from 'react';
import {
  DollarOutlined,
  TruckOutlined,
  ShoppingCartOutlined,
} from '@ant-design/icons';
import { formatFullCurrency } from 'utils/number';
import { OrderSummaryCardProps } from './types';

import * as S from './OrderSummaryCard.styled';

export default function OrderSummaryCard({
  label,
  className,
  deliveryDate = '--',
  billingDate = '--',
  itemsCount = 0,
  subtotal = 0,
  shippingCost = 0,
  total = 0,
  isLkp = false,
  onClearCart,
  onFinalizePurchase,
}: OrderSummaryCardProps) {
  // Shipping carries up to 6 decimals, and the payable total is built from it —
  // both are rendered with the precision the backend actually returned.
  const formatCurrency = formatFullCurrency;

  return (
    <S.SummaryCard className={className}>
      <S.SummaryHeader>{label}</S.SummaryHeader>

      {!isLkp && (
        <>
          <S.Divider />
          <S.Section>
            <S.SectionHeader>
              <TruckOutlined />
              Sobre a entrega
            </S.SectionHeader>
            <S.Divider />
            <S.SectionContent>
              <S.InfoRow>
                <S.InfoLabel>Data de Entrega</S.InfoLabel>
                <S.InfoValue>{deliveryDate}</S.InfoValue>
              </S.InfoRow>
              <S.Divider />
              <S.InfoRow>
                <S.InfoLabel>Data de Faturamento</S.InfoLabel>
                <S.InfoValue>{billingDate}</S.InfoValue>
              </S.InfoRow>
            </S.SectionContent>
          </S.Section>
        </>
      )}

      <S.Divider />

      <S.Section>
        <S.SectionHeader>
          <DollarOutlined />
          Valores e quantidades
        </S.SectionHeader>
        <S.SectionContent>
          <S.InfoRow>
            <S.InfoLabel>Quantidade de itens</S.InfoLabel>
            <S.InfoValue>{itemsCount}</S.InfoValue>
          </S.InfoRow>
          <S.Divider />
          <S.InfoRow>
            <S.InfoLabel>Frete</S.InfoLabel>
            <S.InfoValue>{formatCurrency(shippingCost)}</S.InfoValue>
          </S.InfoRow>
          <S.Divider />
          <S.InfoRow>
            <S.InfoLabel>Total a pagar</S.InfoLabel>
            <S.InfoValue>{formatCurrency(total)}</S.InfoValue>
          </S.InfoRow>
          <S.Divider />
        </S.SectionContent>
      </S.Section>

      <S.ButtonsContainer>
        <S.ClearButton onClick={onClearCart} disabled={itemsCount === 0}>
          Excluir carrinho
        </S.ClearButton>
        <S.ActionButton
          onClick={onFinalizePurchase}
          disabled={itemsCount === 0}
        >
          Finalizar compra <ShoppingCartOutlined />
        </S.ActionButton>
      </S.ButtonsContainer>
    </S.SummaryCard>
  );
}
